const locationsReducer = (
  state = {
    loading: false,
    data: null,
    currentLocation: null,
    distance: null,
    nearestLocations: null,
    selectedLocation: null
  },
  action
) => {
  switch (action.type) {
    case "SET_LOCATIONS_LOADING":
      return {
        ...state,
        loading: action.payload.loading
      };

    case "SET_USER_CURRENT_LOCATION":
      return {
        ...state,
        currentLocation: action.payload.data
      };

    case "SET_USER_DISTANCE":
      return {
        ...state,
        distance: action.payload.distance
      };

    case "SET_LOCATIONS_DATA": {
      // Drop a selection that no longer exists in the refreshed data so a
      // capture can't go out against a location we have no details for.
      const isSelectionStale =
        typeof state.selectedLocation === "string" &&
        !action.payload.data?.[state.selectedLocation];
      return {
        ...state,
        data: action.payload.data,
        ...(isSelectionStale ? { selectedLocation: null, distance: null } : {})
      };
    }

    case "SET_SELECTED_LOCATION":
      return {
        ...state,
        selectedLocation: action.payload.data
      };

    case "SET_NEAREST_LOCATIONS":
      return {
        ...state,
        nearestLocations: action.payload.data
      };

    case "RESET":
      return state;

    default:
      return state;
  }
};
export default locationsReducer;
